import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface PrepareFormQuestionnaireProps {
  formId: string;
  orderId: string;
}

export const prepareFormQuestionnaire = async (
  props: PrepareFormQuestionnaireProps,
) => {
  const token = await getBearerToken();

  const body = {
    form_id: props.formId,
    order_id: props.orderId,
  };

  const response = await fetch(API_ENDPOINTS.PREPARE_FORM_QUESTIONNAIRE, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
    );
  }

  return response.json();
};
